import React from 'react';

import { useGlobalStore } from '@client/store/globalStore/context/globalContext';
import i18n from '@client/utils/i18n';
import { SpectrogramPoint } from '@ledium/types';
import { ItemList } from '@ledium/ui-common';
import { Alert } from '@mui/material';

import LightChannelList from './Components/LightChannelList';
import { LightChannelItem } from './types';

export type { LightChannelItem } from './types';

const LightChannelsMainMenu = () => {
    const {
        globalState: { selectedGroupId }
    } = useGlobalStore();

    function isLocked(lightChannel: LightChannelItem) {
        if (lightChannel.locked?.reason) {
            if (lightChannel.locked.reason === 'RUNNING_PROJECT') {
                return i18n('light_channel_running_project', lightChannel.locked.projectName) as string;
            }
        }
        return false as const;
    }

    function isLinked(lightChannel: LightChannelItem) {
        if (lightChannel.linked?.reason === 'LINKED_PROJECT_AND_SPECTRUM_MIX') {
            return i18n('light_channel_linked_project', lightChannel.linked.spectrumMixName, lightChannel.linked.projectName) as string;
        }
        if (lightChannel.linked?.reason === 'USED_IN_SPECTRUM_MIX') {
            return i18n('light_channel_used_in_mix', lightChannel.linked.spectrumMixName) as string;
        }
        return false as const;
    }

    function chart(item: LightChannelItem): SpectrogramPoint[] {
        return item.spectrogram;
    }

    function filterItems(item: LightChannelItem): boolean {
        if (!selectedGroupId) {
            return true;
        }
        return item.zoneId === selectedGroupId;
    }

    function groupByZone(item: LightChannelItem): string {
        return `Zone: ${item.group?.name ?? 'Unknown'}`;
    }

    return (
        <>
            {!selectedGroupId && (
                <Alert severity="warning" sx={{ mb: 1 }}>
                    {i18n('zone_all_warning')}
                </Alert>
            )}
            <ItemList<LightChannelItem>
                chart={chart}
                isLocked={isLocked}
                isLinked={isLinked}
                allowDuplicate={true}
                ListComponent={LightChannelList}
                addNewDisabled={!selectedGroupId}
                filterItems={filterItems}
                groupBy={selectedGroupId ? undefined : groupByZone}
            />
        </>
    );
};

export default LightChannelsMainMenu;
